import React, { createContext, Dispatch } from "react"
import { EnderecosBloqueadosInicial, EnderecosBloqueadosModel } from "../models/enderecosBloqueadosModel"
import { EnderecosBloqueadosActions } from "./enderecosBloqueadosActions"

interface EnderecosBloqueadosContextValue {
    dados: EnderecosBloqueadosModel
    dispatch: Dispatch<EnderecosBloqueadosActions>
    erroCarregamento: string | null
}

export const EnderecosBloqueadosContext = createContext<EnderecosBloqueadosContextValue>({
    dados: EnderecosBloqueadosInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
})
